import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';
import { userLogoutAction } from 'store/actions/login';
import ContactButton from 'components/common/ContactUsButton';
import PortalButton from 'components/common/Button';
import ContactModal from 'components/common/ContactUs';

export const ErrorPage = ({ statusCode, statusMessage, statusDescription }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const dispatch = useDispatch();

  const handleContactUs = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleSubmit = () => {
    setRedirectToLogin(true);
  };

  useEffect(() => {
    const handleLogout = () => {
      if (statusCode === '403') {
        dispatch(userLogoutAction());
      }
    };
    handleLogout();
  }, [dispatch, statusCode]);

  return (
    <ErrorPage.Container>
      <ErrorPage.StatusCode>{statusCode}</ErrorPage.StatusCode>
      <ErrorPage.StatusMessage>
        {statusMessage}
        <ErrorPage.StyledSubtext>{statusDescription}</ErrorPage.StyledSubtext>
        <PortalButton text="BACK" onSubmit={handleSubmit} />
        <ContactButton handleClick={handleContactUs}>CONTACT US</ContactButton>
        <ContactModal modalVisible={modalVisible} onCancel={handleCancel} />
      </ErrorPage.StatusMessage>
      <ErrorPage.Alias>ALIAS BY GOAT GROUP</ErrorPage.Alias>
      {redirectToLogin && <Redirect to="/login" />}
    </ErrorPage.Container>
  );
};

ErrorPage.Container = styled.div`
  display: flex;
  justify-content: center;
  height: 394px;
  width: 290px;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

ErrorPage.StatusCode = styled.h1`
  height: 50px;
  font-family: ${FONTS.special};
  font-size: 80px;
  line-height: 82px;
  color: ${COLORS.primaryText};
`;

ErrorPage.StatusMessage = styled.h1`
  font-family: ${FONTS.default};
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  width: 289px;
  font-size: 20px;
  line-height: 35px;
  color: ${COLORS.primaryText};
`;

ErrorPage.StyledSubtext = styled.p`
  color: ${COLORS.primaryText};
  font-size: 14px;
  line-height: 16px;
  margin-top: 16px;
  letter-spacing: 0.25px;
  width: 274px;
  justify-content: start;
  display: flex;
  font-weight: 400;
  opacity: 0.5;
  font-family: ${FONTS.default};
`;

ErrorPage.Alias = styled.div`
  font-size: 12px;
  letter-spacing: 3px;
  color: ${COLORS.secondaryText};
  position: absolute;
  bottom: 33px;
`;

ErrorPage.propTypes = {
  statusCode: PropTypes.string,
  statusDescription: PropTypes.string,
  statusMessage: PropTypes.string,
};

export default ErrorPage;
